import clsx from "clsx";

import ProductCard from "@/components/molecules/ProductCard";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import sizes from "@/lib/utils/sizes";
import { ExtendedBundle } from "@/types/addtional-types";
import { getBundleCards } from "../ProductGalleryWithTabs/getGalleryCards";
import styles from "./bundle.module.css";

const Bundle = ({
  blok,
  data,
  preview
}: {
  blok: ExtendedBundle;
  data: Awaited<ReturnType<typeof getBundleCards>>;
  preview: boolean;
}) => {
  return (
    <div className={styles.root} data-layout="blok" data-mobile-bleed="true">
      <div className={styles.title__wrapper}>
        <div className={styles.overtitle__wrapper}>
          {blok.sku && <span>{blok.sku}</span>}
          {blok.category && (
            <span className={styles.category}>{blok.category}</span>
          )}
        </div>
        {blok.title && (
          <h2 className={clsx("blok-big-title", styles.title)}>{blok.title}</h2>
        )}
        {blok.subtitle && (
          <h3 className={clsx("blok-subtitle", styles.subtitle)}>
            {blok.subtitle}
          </h3>
        )}
      </div>

      <div className={styles.main__grid}>
        <div className={styles.left}>
          <div className={styles.left__inner}>
            <StoryblokComponent
              blok={blok?.Media?.[0]}
              sizes={sizes(80, 50)}
              preview={preview}
            />
          </div>
        </div>
        <div className={styles.right}>
          {data?.map((product) => (
            <ProductCard productCard={product} key={product?.core?.name} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bundle;
